<template>
    <modal size="md" class="SelectInstagramBusinessPropertyModal" @close="close">
        <div class="text-center">
            <h3>Vælg en Instagram Business Facebook side</h3>

            <!--            <div v-if="channel.resource_id !== null" class="alert alert-danger">-->
            <!--                <p>-->
            <!--                    Det er i øjeblikket ikke muligt at skifte Instagram Business konto.-->
            <!--                </p>-->
            <!--                <p>-->
            <!--                    Hvis du har forbundet til den forkerte konto, kan du afbryde forbindelsen til-->
            <!--                    mediet, og forbinde på ny.-->
            <!--                </p>-->
            <!--            </div>-->

            <form @submit.prevent="update">
                <div class="m-xl">
                    <form-item field="resource_id" :form="form" class="form-group-lg">
                        <label class="control-label">Instagram konto</label>
                        <select v-model="form.resource_id" class="form-control input-lg" autofocus>
                            <option :value="null">
                                Vælg fra listen
                            </option>
                            <option
                                v-for="resource in channel.resources"
                                :key="resource.id"
                                :value="resource.id"
                            >
                                {{ resource.name }}
                            </option>
                        </select>
                    </form-item>
                </div>
                <button type="submit" class="btn btn-xl btn-success btn-load" :disabled="form.busy">
                    Forbind konto
                </button>
            </form>
        </div>
    </modal>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.SelectInstagramBusinessPropertyModal {
}
</style>
<script type="text/babel">
export default {
    props: ['channel'],

    data() {
        return {
            form: new SparkForm({
                resource_id: this.channel.resource_id,
            }),
        }
    },

    methods: {
        update() {
            Spark.put(route('api.channel.update', this.channel.id), this.form).then(this.close)
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>
